import DittoHeader from '@/components/headers/DittoHeader.vue'
import AddlServiceForm from '@/views/addl-service-form/router.vue'
import ServiceCardView from '@/views/service-card/index.vue'
import ServiceForm from '@/views/service-form/index.vue'
import AboutViewVue from '@/views/services/golden/AboutView.vue'
import EligibilityViewVue from '@/views/services/golden/EligibilityView.vue'
import ListViewVue from '@/views/services/golden/ListView.vue'
import GoldenRouter from '@/views/services/golden/router.vue'
import CancellationView from '@/views/services/public-visa/CancellationView.vue'
import ExtensionViewVue from '@/views/services/public-visa/ExtensionView.vue'
import IssuenewViewVue from '@/views/services/public-visa/IssuenewView.vue'
import ModifyViewVue from '@/views/services/public-visa/ModifyView.vue'
import PreEntryExtension from '@/views/services/public-visa/PreEntryExtension.vue'
import PublicvisaRouter from '@/views/services/public-visa/router.vue'
import PublicCategories from '@/views/services/public/categories.vue'
import PublicServicesGrid from '@/views/services/public/grid.vue'
import PublicView from '@/views/services/public/index.vue'
import ServicesRouter from '@/views/services/router.vue'
import MySponsored from '@/views/service-card/MySponsored.vue'
import FavServiceCard from '@/views/service-card/FavServiceCard.vue'
import OneclickServices from '@/views/services/oneclick/index.vue'
import PublicVisaApplicationTracking from '@/views/services/public-visa/application-tracking/index.vue'
import PublicServicesApplicationTracking from '@/views/services/public/application-tracking/index.vue'
import GoldenResidencesIndex from '@/views/services/golden/index.vue'
import GolResServicesRouter from '@/views/services/golden/GolResServices/router.vue'

export default [
  {
    path: '/services',
    name: 'ServicesRoot',
    meta: {
      breadcrumb: { label: 'Services', clickable: false }
    },
    components: {
      default: ServicesRouter,
      navbar: DittoHeader
    },
    children: [
      {
        path: '',
        name: 'ServicesRouter',
        redirect: '/services/public'
      },
      {
        path: 'public/application-tracking',
        name: 'PublicServicesApplicationTracking',
        components: {
          default: PublicServicesApplicationTracking,
          navbar: DittoHeader
        }
      },
      {
        path: 'public',
        name: 'PublicView',
        meta: {
          breadcrumb: { label: 'visitorServices', clickable: false }
        },
        components: {
          default: PublicView
        },
        children: [
          {
            path: '',
            name: 'PublicCategories',
            meta: {
              breadcrumb: { hidden: true }
            },
            component: PublicCategories
          },
          {
            path: ':category',
            name: 'ServicesGrid',
            component: PublicServicesGrid
          }
        ]
      },
      {
        path: 'golden-residency',
        meta: {
          breadcrumb: { label: 'goldenServices', clickable: false }
        },
        component: GoldenRouter,
        children: [
          {
            path: '',
            component: GoldenResidencesIndex,
            redirect: { name: 'GolResInOrOut' }
          },
          {
            path: 'services',
            component: GolResServicesRouter,
            children: [
              {
                path: '',
                name: 'GolResInOrOut',
                component: () => import('@/views/services/golden/GolResServices/GolResInOrOut.vue')
              },
              {
                path: 'inside-UAE',
                name: 'GolResInside',
                component: () => import('@/views/services/golden/GolResServices/GolResInside.vue')
              },
              {
                path: 'outside-UAE',
                name: 'GolResOutside',
                component: () => import('@/views/services/golden/GolResServices/ServiceGrid.vue')
              },
              {
                path: 'inside-UAE/:filter',
                name: 'GolResServicesGrid',
                component: () => import('@/views/services/golden/GolResServices/ServiceGrid.vue')
              }
            ]
          },
          {
            path: 'about',
            name: 'GoldenResidencyAbout',
            meta: {
              breadcrumb: {
                label: 'aboutGoldenResidency'
              }
            },
            component: AboutViewVue
          },
          {
            path: 'list',
            name: 'GoldenResidencyList',
            meta: {
              breadcrumb: {
                label: 'goldenServices'
              }
            },
            component: ListViewVue
          },
          {
            path: 'eligibility',
            name: 'GoldenResidencyEligibility',
            meta: {
              breadcrumb: {
                label: 'checkEligibility'
              }
            },
            component: EligibilityViewVue
          }
        ]
      },

      {
        path: 'public-visa/application-tracking',
        name: 'PublicVisaApplicationTracking',
        components: {
          default: PublicVisaApplicationTracking,
          navbar: DittoHeader
        }
      },
      {
        path: 'public-visa',
        meta: {
          breadcrumb: { label: 'Public Visa Services', clickable: false }
        },
        component: PublicvisaRouter,
        children: [
          {
            path: '',
            name: 'PublicvisaView',
            redirect: '/services/public-visa/issue-new'
          },

          {
            path: 'issue-new',
            name: 'PublicvisaIssuenew',
            meta: {
              breadcrumb: {
                label: 'issueNewVisa'
              }
            },
            component: IssuenewViewVue
          },
          // 'modification',
          // 'cancellation',
          // 'pre-entry-extension'
          {
            path: 'extension',
            name: 'PublicvisaExtension',
            meta: {
              breadcrumb: {
                label: 'extensionVisa'
              }
            },
            component: ExtensionViewVue
          },
          {
            path: 'modification',
            name: 'PublicvisaModification',
            meta: {
              breadcrumb: {
                label: 'modificationVisa'
              }
            },
            component: ModifyViewVue
          },
          {
            path: 'cancellation',
            name: 'PublicvisaCancellation',
            meta: {
              breadcrumb: {
                label: 'cancellationVisa'
              }
            },
            component: CancellationView
          },
          {
            path: 'pre-entry-extension',
            name: 'PublicvisaPreentry',
            meta: {
              breadcrumb: {
                label: 'PreEntryExtension'
              }
            },
            component: PreEntryExtension
          }
        ]
      },
      {
        path: ':category?/form/:serviceId',
        name: 'ServiceForm',
        component: ServiceForm
      },
      {
        path: ':category?/form/additional/:serviceSlug',
        name: 'AddlServiceForm',
        component: AddlServiceForm
      },
      {
        path: ':category?/:serviceId/service-card',
        name: 'ServiceCardView',
        component: ServiceCardView
      },
      {
        path: ':category?/:serviceId/service-card/share',
        name: 'ShareServiceCardView',
        components: {
          default: () => import('@/views/service-card/ShareServiceCard.vue')
        }
      },
      {
        path: '/services/my-sponsored',
        name: 'MySponsored',
        component: MySponsored
      },
      {
        path: '/services/service-card',
        name: 'FavServiceCard',
        component: FavServiceCard
      },
      {
        path: '/oneclick-services',
        name: 'OneclickServices',
        component: OneclickServices
      }
    ]
  }
]
